import { render, staticRenderFns } from "./site-header.vue?vue&type=template&id=64dc5345"
import script from "./site-header.vue?vue&type=script&lang=js"
export * from "./site-header.vue?vue&type=script&lang=js"
import style0 from "./site-header.vue?vue&type=style&index=0&id=64dc5345&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports